export enum CardAction {
  replace = "replace",
  reissue = "reissue",
}
